import React from "react";
import { Empty } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ReactComponent as CheckedIcon } from "../../../../assests/images/checked.svg";
import unCheckedIcon from "../../../../assests/icons/uncheck.png";
import { MdOutlineEdit } from "react-icons/md";

export default function LoanListItem({
  dataSource,
  handleChange,
  handleShowBalance,
  setVisible,
  setSelectedDetails,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      {dataSource.length === 0 && (
        <div style={{ marginTop: 20 }}>
          <Empty
            description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })}
          />
        </div>
      )}

      {dataSource.map((account, idx) => (
        <div key={idx}>
          <div
            className={
              account.checked ? "list-item selected-row-wrapper" : "list-item"
            }
            style={{ marginBottom: 10 }}
          >
            <div
              className={
                account.checked
                  ? "account-row-data selected-row list-row"
                  : "account-row-data list-row"
              }
              style={{ margin: 0, paddingLeft: 10 }}
            >
              <div className="list-row-display-item">
                <div>
                  {account.checked ? (
                    <CheckedIcon
                      className="checked"
                      onClick={() => handleChange(false, account)}
                      height={20}
                    />
                  ) : (
                    <img
                      onClick={() => handleChange(true, account)}
                      src={unCheckedIcon}
                      alt="unCheck"
                      height={20}
                      className="unchecked"
                    />
                  )}
                </div>
                <div>
                  <span className="d-flex justify-content-between">
                    <span
                      className="accNamespan acc-shortname"
                      title={account.accountType || account.accountNo}
                    >
                      {account.accountType} {account.accountNo}
                    </span>
                  </span>
                  <span className="accNamespan acc-shortname hide-xs">
                    {account.acctShortName || account.accountName}{" "}
                    <MdOutlineEdit
                      onClick={() => {
                        setVisible(true);
                        setSelectedDetails(account);
                      }}
                      style={{ marginTop: "-5px", fontSize: 15 }}
                    />
                  </span>
                </div>
              </div>
              <div align="right">
                <span className="accNamespan">{account.accountClassDesc}</span>
                <div className="list-item-heading hide-xs">
                    {account.branchName || "-"}
                  </div>
              </div>
            </div>
            <div
              className={
                account.checked
                  ? "sub-options sub-options-active "
                  : "sub-options"
              }
            >
              <span
                onClick={() =>
                  navigate("/accounts/loan/summary", { state: { ...account } })
                }
              >
                {t("pages.my_accounts.common_my_accounts.ac_details", {
                  defaultValue: "A/c Details",
                })}
              </span>
              <span
                onClick={() =>
                  navigate("/accounts/loan/statement", {
                    state: { ...account },
                  })
                }
              >
                {t("navigation.statement", {
                  defaultValue: "Statement",
                })}
              </span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
